<template>
  <div>
    <h2 class="text-2xl font-bold mb-4">{{ $t("workExperience") }}</h2>
    <div class="space-y-6 text-sm">
      <div
        v-for="job in jobs"
        :key="job.id"
        class="p-4 rounded-xl transition-all duration-300 hover:shadow-lg relative group"
        @mouseenter="emitSkillIds(job.skillIds)"
        @mouseleave="emitSkillIds([])"
      >
        <!-- Glossy overlay -->
        <div
          class="absolute inset-0 rounded-xl transition-opacity duration-300 opacity-0 group-hover:opacity-100 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm pointer-events-none"
        ></div>

        <!-- Content -->
        <div class="relative z-10">
          <h3 class="font-bold">{{ $t(job.title) }}</h3>
          <p class="italic">{{ $t(job.company) }}</p>
          <p v-if="job.period" class="italic">{{ $t(job.period) }}</p>
          <ul v-if="job.responsibilities" class="list-disc ml-5 mt-1">
            <li
              v-for="(resp, idx) in getResponsibilities(job.responsibilities)"
              :key="idx"
            >
              {{ resp }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { jobs, JobItem } from "@/data/jobs";

@Options({})
export default class WorkExperience extends Vue {
  jobs: JobItem[] = jobs;

  emitSkillIds(skillIds: string[]) {
    this.$emit("active-skill-ids", skillIds);
  }

  getResponsibilities(key: string): string[] {
    const val = (this.$tm as (key: string) => unknown)(key);
    return Array.isArray(val) ? (val as string[]) : [];
  }
}
</script>

<style scoped>
.group:hover {
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.1);
}

@supports (backdrop-filter: blur(10px)) {
  .group:hover {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }
}
</style>
